<script lang="ts">
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';

    interface Props {
        count: number;
    }

    const { count }: Props = $props();

    const wiring = injectWiring(['trackingService']);

    const formattedCount = $derived.by(() => new Intl.NumberFormat('de-DE').format(count));

    const rankingtransparencyUrl = btoa('/static-proxy/dundee/sheets/ranking-transparency.html');
</script>

<oc-sheet-v1
    id="reptile-ranking-transparency-sheet"
    headline="Warum zeigen wir dir diese Produkte?"
    full-height={true}
    onoc-sheet-open={() => {
        wiring.trackingService?.trackInteraction('ranking_info_open');
    }}
    onoc-sheet-close={() => {
        wiring.trackingService?.trackInteraction('ranking_info_close');
    }}
    base64-url={rankingtransparencyUrl}
>
</oc-sheet-v1>

<div class="reptile-item-count__header">
    <span class="reptile-item-count__header--splitted">
        <span class="reptile-item-count__item-count" data-item-count={count}>{formattedCount} Produkte</span>
        <oc-icon-button-v3
            variant="transparent"
            icon="info-hint"
            size={'25'}
            icon-color={'var(--oc-semantic-color-text-secondary)'}
            oc-aria-label="Warum zeigen wir dir diese Produkte?"
            data-testid="reptile-ranking-transparency-button"
            data-oc-sheet-v1-open=""
            data-oc-sheet-v1-open.id="reptile-ranking-transparency-sheet"
        ></oc-icon-button-v3>
    </span>
</div>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@otto-ec/otto-components-utils/scss/mixins';

    .reptile-item-count {
        &__header {
            display: flex;
            flex-direction: row;
            padding-top: tokens.$oc-semantic-spacing-25;
            padding-bottom: tokens.$oc-semantic-spacing-50;
            align-items: center;
            justify-content: space-between;
            background-color: tokens.$oc-semantic-color-canvas-background;

            &--splitted {
                display: inline-flex;
                align-items: center;
                gap: tokens.$oc-semantic-spacing-50;
            }
        }

        &__item-count {
            margin-left: tokens.$oc-semantic-spacing-100;
            color: tokens.$oc-semantic-color-text-secondary;
            font: tokens.$oc-semantic-font-copy-75;

            @include mixins.breakpoint-from-l($to: false) {
                font: tokens.$oc-semantic-font-copy-100;
            }
        }
    }
</style>
